import UserDetails from './userDetails';

const UserTile = ({ currentUser, userProfile, editing }) => {
  const email = currentUser?.email || 'Not available';
  const photoUrl = userProfile?.profileImage || null;
  const firstName = userProfile?.firstName || '';
  const lastName = userProfile?.lastName || '';
  const neighborhood = userProfile?.neighborhood || '';
  const bio = userProfile?.bio || '';
  const phoneNumber = userProfile?.phoneNumber || '';
  const fullName = [firstName, lastName].filter(Boolean).join(' ');
  const fallbackInitial = firstName ? firstName.charAt(0).toUpperCase() : (email ? email.charAt(0).toUpperCase() : 'U');

  const calculateDaysSince = (timestamp) => {
    if (!timestamp) return null;
    const accountDate = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    const today = new Date();
    const diffTime = Math.abs(today - accountDate);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const daysSinceCreation = userProfile?.accountCreated
    ? calculateDaysSince(userProfile.accountCreated)
    : null;

  const getDaysMessage = (days) => {
    if (days === null) return null;
    if (days === 0) return "Thanks for joining us today!";
    if (days === 1) return "Thanks for being with us for 1 day";
    return `Thanks for being with us for ${days} days`;
  };

  return (
    <div className="user-tile">
      <div className="profile-header">
        {photoUrl ? (
          <img className="profile-avatar" src={photoUrl} alt="User profile" />
        ) : (
          <div className="profile-avatar profile-avatar--placeholder" aria-hidden="true">
            {fallbackInitial}
          </div>
        )}
        <div className="profile-copy">
          <h1 className="profile-name">{fullName || 'Your Profile'}</h1>
          {daysSinceCreation !== null && (
            <p className="dashboard-subtitle">
              {getDaysMessage(daysSinceCreation)}
            </p>
          )}
        </div>
      </div>

      {!editing && <UserDetails email={email} neighborhood={neighborhood} phoneNumber={phoneNumber} bio={bio} />}
    </div>
  );
};

export default UserTile;
